import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import Components from "..";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import {
  align,
  font,
  fontColor,
  fontSize,
  formatBlock,
  hiliteColor,
  horizontalRule,
  lineHeight,
  list,
  paragraphStyle,
  table,
  template,
  textStyle,
  image,
  link,
} from "suneditor/src/plugins";
import "suneditor/dist/css/suneditor.min.css"; // Import Sun Editor's CSS File
import { doctorActions, patientActions, ehrActions } from "../../core/actions";
import { CASERECORD, DISCHARGESUMMARY } from "../../shared/constants";
import { makeStyles } from "@material-ui/core";
import TextField from "@mui/material/TextField";
import { helperServices } from "../../shared/helper";
import { PRINT_FILE, PRINT_PREVIEW } from "../../shared/constants";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Alert } from "@mui/material";
import { DOCTOR_ROLE, DIRECTOR_ROLE } from "../../shared/constants";
import { format } from "date-fns";
import { Box, Paper } from "@mui/material";
import { saveDischargeSummary } from "../../core/actions/patientActions";
import { Switch, FormControlLabel } from "@mui/material";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
function MnhDischargeSummary(props) {
  console.log("props", props);
  const [enteredBy, setEnteredBy] = useState("");
  const [isOn, setIsOn] = useState(false);
  const [printPreviewType, setPrintPreviewType] = useState("");
  const [customFields, setCustomFields] = useState([]);
  const [showAddFieldModal, setShowAddFieldModal] = useState(false);
  const [newFieldName, setNewFieldName] = useState("");
  const [newFieldValue, setNewFieldValue] = useState("");
  const [patientEhrid, setPatientEhrId] = useState("");
  const [highlightedDoctorIndex, setHighlightedDoctorIndex] = useState(-1);
  const [focusedField, setFocusedField] = useState(null);
  const options = {
    showPathLabel: false,
    plugins: [
      align,
      font,
      fontColor,
      fontSize,
      formatBlock,
      hiliteColor,
      horizontalRule,
      lineHeight,
      list,
      paragraphStyle,
      table,
      template,
      textStyle,
      image,
      link,
    ],
    buttonList: [
      ["undo", "redo"],
      //["font", "fontSize", "formatBlock"],
      // ["paragraphStyle"],
      ["bold", "underline", "italic"],
      ["fontColor"],
      ["removeFormat"],
      //  "/", // Line break
      //["outdent", "indent"],
      ["align", "list"],
      //["table", "link", "image"],
    ],
    formats: ["p", "div", "h1", "h2", "h3", "h4", "h5", "h6"],
    font: [
      "Arial",
      "Calibri",
      "Comic Sans",
      "Courier",
      "Garamond",
      "Georgia",
      "Impact",
      "Lucida Console",
      "Palatino Linotype",
      "Segoe UI",
      "Tahoma",
      "Times New Roman",
      "Trebuchet MS",
    ],
  };

  const [summary, setSummary] = useState({
    "Chief Complaints": "",
    "Patient Status": "",
    "History of presenting illness": "",
    "History of present pregnancy": "",
    "Obstetric history": "",
    "Menstrual history": "",
    "Past History": "",
    "Family History": "",
    "Drug Allergy": "",
    "General physical examination": "",
    "Systemic Examination": "",
    "Provisional Diagnosis": "",
    Investigations: "",
    "Treatment given": "",
    "Course in the hospital": "",
    "Advice on discharge": "",
    "Final Diagnosis": "",
    // "Room Number": "",
    "Referred By": "",
    "Department Unit": "",
    "Referred To": "",
    "Emergency Contact": "",
    dischargedt: "",
  });
  const [dischargeId, setDischargeId] = useState();
  const toggleSwitch = () => {
    setIsOn(!isOn);
  };

  const [patientdetails, setPatientDetails] = useState({
    name: "",
    visitDate: "",
  });
  const [dischrgeDetails, setDischrgeDetails] = useState({
    id: "",
    patientId: "",
    dischargeDate: "",
  });

  const [selectedDoctorNames, setSelectedDoctorNames] = useState([]); //  new state for multiple treating doctors

  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [patientRevisitdetails, setPatientRevisitdetails] = useState("");
  const [dischargedt, setDischargedt] = useState("");
  const [filterdProList, setfilterdProList] = useState();
  const [loadsummary, setLoadSummary] = useState(false);
  const [formErrors, setFormErrors] = useState({
    "Final Diagnosis": "",
    "Follow Up Date": "",
    "Chief Complaints": "",
    "Menstrual history": "",
    "Obstetric history": "",
    "Drug Allergy": "",
    "Patient Status": "",
    "History of present pregnancy": "",
    "History of presenting illness": "",
    "Past History": "",
    "Family History": "",
    "General physical examination": "",
    "Systemic Examination": "",
    "Provisional Diagnosis": "",
    Investigations: "",
    "Department Unit": "",
    "Treatment given": "",
    "Course in the hospital": "",
    "Advice on discharge": "",
    "Follow Up": "",
  });

  const useStyles = makeStyles((theme) => ({
    redAsterisk: {
      color: "red",
    },
  }));

  const styles = `
  /* Highlight focused SunEditor */
.focused-editor .sun-editor {
  border: 2px solid #1976d2 !important;
  border-radius: 4px;
  overflow: hidden;
}

/* Remove any inner borders that conflict */
.focused-editor .sun-editor .se-wrapper,
.focused-editor .sun-editor .se-wrapper-inner {
  border: none !important;
}

/* Standard form controls */
.form-control:focus,
select.form-control:focus,
input.form-control:focus {
  border: 2px solid #1976d2 !important;
  box-shadow: 0 0 0 0.2rem rgba(25, 118, 210, 0.25) !important;
  outline: none !important;
}

`;

  // Add this style object near your useStyles
  const focusedFieldStyle = {
    border: "2px solid #1976d2",
    borderRadius: "4px",
    transition: "border 0.2s ease-in-out",
  };

  // Then update each SunEditor wrapper div to apply the style conditionally:

  const classes = useStyles();
  const [details, setDetails] = useState({
    id: "",
    patientId: "",
    visitId: "",
    markForDel: "",
    groupname: "",
    preparedBy: "",
    approver: "",
  });
  const [doctorList, setDoctorList] = useState([]);
  // const [counsellorList, setCounsellorList] = useState([]);
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const dispatch = useDispatch();

  const [dischargePrint, setdischargePrint] = useState(false);
  const [fullName, setFullName] = useState("");
  const [roomName, setRoomName] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [pId, setPId] = useState("");
  const doctorsDetail = useSelector(
    (state) => state.doctorDetailsState.doctorList
  );
  const [selectedOptionDoc, setSelectedOptionDoc] = useState(null);
  const [selectedItemsDoc, setSelectedItemsDoc] = useState([]);
  const [followUpDateFlag, setFollowUpDateFlag] = useState(false);
  const [dischargeDateFlag, setDischargeDateFlag] = useState(false);
  const [todayDate, setTodayDate] = useState(new Date());
  const [doctors, setDoctors] = useState([]);
  const [dischargeSummarytemplate, setDischargeSummarytemplate] = useState();

  const getUserInfo = () => {
    let name = helperServices.getLoggedUserName();
    let formattedName = helperServices.getFullName(name, null, null);
    let role = JSON.parse(localStorage.getItem("role"));
    let displayTitle = "";

    if (role === DOCTOR_ROLE || role === DIRECTOR_ROLE) {
      let personData = JSON.parse(localStorage.getItem("doctorInformation"));
      if (
        personData &&
        (personData.type === "counsellor" ||
          personData.type.toLowerCase() === "doctor")
      ) {
        displayTitle = personData.displaytitle;
      }
      formattedName = displayTitle + formattedName;
    }

    return formattedName;
  };

  const [roomList, setRoomList] = useState([]);
  useEffect(() => {
    getDoctorList();
    getPatientProfile();
    console.log("selected : ", selectedItemsDoc);
    document.getElementById("mainpage").style.paddingLeft = "0px";
    document.getElementById("sidebar").style.display = "none";
    getDischargeSummarytemplateById();
    console.log("ehrid", patientEhrid);
    setEnteredBy(getUserInfo());
    setTimeout(() => {
      focusElement("Course in the hospital");
      setFocusedField("Course in the hospital");

      // Add Tab handling to all SunEditor fields
      const allEditors = document.querySelectorAll(".sun-editor-editable");
      allEditors.forEach((editor) => {
        editor.addEventListener("keydown", (e) => {
          if (e.key === "Tab") {
            e.preventDefault();
            e.stopPropagation();

            // Get the field name from the parent element
            const fieldWrapper = editor.closest("[data-field]");
            if (fieldWrapper) {
              const fieldName = fieldWrapper.getAttribute("data-field");
              handleTabNavigation(e, fieldName);
            }
          }
        });
      });
    }, 200);
  }, []);

  const getDischargeSummarytemplateById = () => {
    let data = "";
    const jsonSchema = {};
    let patient = {};
    let templateId = "Discharge Summary";
    dispatch(
      ehrActions.getTemplateById(data, templateId, patient, (resCb) => {
        if (resCb) {
          console.log("Discharge Summary rescb", resCb);
          console.log("Discharge Summary", resCb);
          setDischargeSummarytemplate(resCb);
        }
      })
    );
    return dischargeSummarytemplate;
  };

  //

  const patientSummaryClick = (docList, counList) => {
    details.patientId = props.match.params.patientid;
    details.visitId = props.match.params.visitid;
    details.groupname = DISCHARGESUMMARY;
    details.markForDel = false;

    dispatch(
      patientActions.getDischargeSummary(summary, details, (resCb) => {
        if (resCb) {
          // Set doctor list
          if (resCb.vaList && resCb.vaList.length > 0) {
            let tempSelectedDoctors = [];
            let tempDoctorNames = [];

            resCb.vaList.forEach((va) => {
              docList.forEach((doctor) => {
                if (
                  doctor &&
                  doctor.gvId === va.targetid &&
                  doctor.type.toLowerCase() === "doctor"
                ) {
                  doctor.groupname = va.groupname || "Treating_Doctor";

                  if (
                    !tempSelectedDoctors.some(
                      (item) => item.gvId === doctor.gvId
                    )
                  ) {
                    tempSelectedDoctors.push(doctor);

                    const fullName = `${doctor.displaytitle} ${doctor.first_name
                      } ${doctor.last_name || ""}`;
                    tempDoctorNames.push(fullName);
                  }
                }
              });
            });

            setSelectedItemsDoc(tempSelectedDoctors);
            setSelectedDoctorNames(tempDoctorNames);
            setDoctors(tempDoctorNames);

            if (tempSelectedDoctors.length > 0) {
              const firstDoc = tempSelectedDoctors[0];
              setSelectedDoctor(
                firstDoc.displaytitle + firstDoc.first_name
              );
            }
          }

          // Handle discharge date
          if (resCb.visit && resCb.visit.dischargeDate) {
            const dt = new Date(resCb.visit.dischargeDate);
            const formatted = format(dt, "yyyy-MM-dd'T'HH:mm");
            setDischargedt(formatted);
            summary["dischargedt"] = formatted;
          } else {
            const now = new Date();
            const formatted = format(now, "yyyy-MM-dd'T'HH:mm");
            setDischargedt(formatted);
          }

          if (resCb.revisit && resCb.revisit.scheduleddate) {
            setPatientRevisitdetails(resCb.revisit.scheduleddate);
          } else {
            const future = new Date();
            future.setDate(future.getDate() + 14);
            const formatted = format(future, "yyyy-MM-dd");
            setPatientRevisitdetails(formatted);
          }

          // Handle DISCHARGESUMMARY data loading
          if (resCb.procedureList && resCb.procedureList.length > 0) {
            const filterList = resCb.procedureList.filter(
              (item) => item.groupname === DISCHARGESUMMARY
            );

            console.log("Filtered DISCHARGESUMMARY list:", filterList); // DEBUG LOG

            let updatedSummary = { ...summary };
            let updatedProList = [];

            filterList.forEach((item) => {
              console.log(
                `Loading field: ${item.claSS}, value length: ${item.notes?.length || 0
                }`
              ); // DEBUG LOG

              // CRITICAL FIX: Set the value directly from item.notes
              updatedSummary[item.claSS] = item.notes || "";
              updatedProList.push(item);

              // Special check for "Course in the hospital"
              if (item.claSS === "Course in the hospital") {
                console.log("Found 'Course in the hospital' data:", item.notes); // DEBUG LOG
              }
            });

            // IMPORTANT: Update the summary state BEFORE extracting custom fields
            setSummary(updatedSummary);
            setfilterdProList(updatedProList);

            console.log("Updated summary state:", updatedSummary); // DEBUG LOG

            // Extract custom fields
            const predefinedFields = [
              ...Object.keys(formErrors),
              "Referred By",
              "Referred To",
              "Emergency Contact",
              "dischargedt",
              "Department Unit",
              "Follow Up Date",
            ];

            const customKeys = Object.keys(updatedSummary).filter(
              (key) => !predefinedFields.includes(key) && key !== "dischargedt"
            );
            const extractedFields = customKeys.map((key) => ({
              key,
              name: key.replace(/_/g, " "),
            }));

            // Ensure custom field values are preserved
            let updatedSummaryWithCustomFields = { ...updatedSummary };
            customKeys.forEach((key) => {
              updatedSummaryWithCustomFields[key] = updatedSummary[key] || "";
            });

            setCustomFields(extractedFields);

            // CRITICAL: Set the final summary state with all data including "Course in the hospital"
            setSummary(updatedSummaryWithCustomFields);

            console.log(
              "Final summary with custom fields:",
              updatedSummaryWithCustomFields
            ); // DEBUG LOG
          } else {
            // Handle CASERECORD fallback
            details.groupname = CASERECORD;

            dispatch(
              patientActions.getDischargeSummary(summary, details, (resCb2) => {
                if (resCb2 && resCb2.procedureList) {
                  const filterList = resCb2.procedureList.filter(
                    (item) => item.groupname === CASERECORD
                  );

                  console.log("Filtered CASERECORD list:", filterList); // DEBUG LOG

                  let updatedSummary = { ...summary };
                  let updatedProList = [];

                  filterList.forEach((item) => {
                    console.log(
                      `Loading field from CASERECORD: ${item.claSS
                      }, value length: ${item.notes?.length || 0}`
                    ); // DEBUG LOG

                    updatedSummary[item.claSS] = item.notes || "";
                    updatedProList.push(item);

                    if (item.claSS === "Course in the hospital") {
                      console.log(
                        "Found 'Course in the hospital' in CASERECORD:",
                        item.notes
                      ); // DEBUG LOG
                    }
                  });

                  setSummary(updatedSummary);
                  setfilterdProList(updatedProList);

                  // Extract custom fields
                  const predefinedFields = [
                    ...Object.keys(formErrors),
                    "Referred By",
                    "Referred To",
                    "Emergency Contact",
                    "dischargedt",
                    "Department Unit",
                    "Follow Up Date",
                  ];

                  const customKeys = Object.keys(updatedSummary).filter(
                    (key) =>
                      !predefinedFields.includes(key) && key !== "dischargedt"
                  );
                  const extractedFields = customKeys.map((key) => ({
                    key,
                    name: key.replace(/_/g, " "),
                  }));

                  let updatedSummaryWithCustomFields = { ...updatedSummary };
                  customKeys.forEach((key) => {
                    updatedSummaryWithCustomFields[key] =
                      updatedSummary[key] || "";
                  });

                  setCustomFields(extractedFields);
                  setSummary(updatedSummaryWithCustomFields);

                  console.log(
                    "Final summary from CASERECORD:",
                    updatedSummaryWithCustomFields
                  ); // DEBUG LOG
                }
              })
            );
          }
        }
      })
    );
  };

  const handleTabNavigation = (e, currentFieldName) => {
    if (e.key === "Tab") {
      e.preventDefault();
      e.stopPropagation();

      const currentIndex = fieldOrder.indexOf(currentFieldName);
      let nextIndex;

      if (e.shiftKey) {
        // Shift+Tab: go to previous field
        nextIndex = currentIndex > 0 ? currentIndex - 1 : fieldOrder.length - 1;
      } else {
        // Tab: go to next field
        nextIndex = currentIndex < fieldOrder.length - 1 ? currentIndex + 1 : 0;
      }

      const nextFieldName = fieldOrder[nextIndex];
      setFocusedField(nextFieldName);

      // Focus the next element after a short delay
      setTimeout(() => {
        focusElement(nextFieldName); // Use the focusElement function instead
      }, 50);
    }
  };

  const handleDoctorSelectKeyDown = (e) => {
    const selectElement = e.target;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      // Navigate down through options
      const newIndex = Math.min(
        highlightedDoctorIndex + 1,
        doctorList.length - 1
      );
      setHighlightedDoctorIndex(newIndex);
      selectElement.selectedIndex = newIndex + 1; // +1 because of the disabled option
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      // Navigate up through options
      const newIndex = Math.max(highlightedDoctorIndex - 1, 0);
      setHighlightedDoctorIndex(newIndex);
      selectElement.selectedIndex = newIndex + 1;
    } else if (e.key === "Enter") {
      e.preventDefault();
      // Add the selected doctor when Enter is pressed
      if (
        highlightedDoctorIndex >= 0 &&
        highlightedDoctorIndex < doctorList.length
      ) {
        const selectedDoctor = doctorList[highlightedDoctorIndex];
        handleOptionSelect(selectedDoctor.gvId, "Treating_Doctor");
        // Reset the select
        selectElement.value = "";
        selectElement.size = 0;
        setHighlightedDoctorIndex(-1);
      }
    } else if (e.key === "Tab") {
      // Handle tab navigation to next field
      handleTabNavigation(e, "treating-doctor");
    } else if (e.key === "Escape") {
      // Close dropdown on Escape
      selectElement.size = 0;
      setHighlightedDoctorIndex(-1);
    }
  };

  // Update your focusElement function to handle both types
  const focusElement = (fieldName) => {
    let element = null;

    // Check if it's a regular form element (button, input, select)
    if (
      fieldName.includes("button") ||
      fieldName.includes("date") ||
      fieldName === "treating-doctor"
    ) {
      element = document.querySelector(`[data-tab-field="${fieldName}"]`);
    } else {
      // For SunEditor fields
      element = document.querySelector(
        `[data-field="${fieldName}"] .sun-editor-editable`
      );
    }

    if (element) {
      element.focus();
    }
  };

  // Alternative: Single function approach that checks both selectors
  const focusElementImproved = (fieldName) => {
    // Try to find a SunEditor field first
    let element = document.querySelector(
      `[data-field="${fieldName}"] .sun-editor-editable`
    );

    // If not found, try to find a regular form element
    if (!element) {
      element = document.querySelector(`[data-tab-field="${fieldName}"]`);
    }

    if (element) {
      element.focus();
    } else {
      console.log(`Could not find element for: ${fieldName}`);
    }
  };

  const fieldOrder = [
    "Course in the hospital",
    "Emergency Contact",
    "Referred By",
    "Referred To",
    "Final Diagnosis",
    "Chief Complaints",
    "Patient Status",
    ...(isOn
      ? [
        "History of present pregnancy",
        "Past History",
        "Family History",
        "Obstetric history",
        "Menstrual history",
      ]
      : ["Past History", "Family History", "History of presenting illness"]), // Changed order
    "Systemic Examination",
    "General physical examination",
    "Treatment given",
    "Investigations",
    "Provisional Diagnosis",
    "Advice on discharge",
    "Drug Allergy",
    "Follow Up",
    ...customFields.map((field) => field.key),
    "treating-doctor",
    "follow-up-date",
    "discharge-date",
    "save-button",
    "print-button",
    "preview-button",
    "add-field-button",
  ];

  const getPatientProfile = () => {
    let patientId = props.match.params.patientid;
    console.log("doctorlist : ", doctorsDetail);
    dispatch(
      patientActions.getPatientProfile(patientId, (resCb) => {
        if (resCb) {
          console.log(
            "getPatientProfile resp age phno and last visited:",
            resCb
          );
          setPatientEhrId(resCb.ehrid);
          dispatch(patientActions.setPatientDetails(resCb));
          let fullname = `${resCb.fname} ${resCb.mname || ""} ${resCb.lname || ""
            }`;
          let paId = resCb.patientId || "";
          console.log("Full Name:", fullname);
          setFullName(fullname);
          setPId(paId);
          let room =
            resCb.room && resCb.room.roomName ? resCb.room.roomName : "";
          let phone = resCb.phno;
          let roomList = resCb.roomList || [];
          setRoomName(room);
          setPhoneNum(phone);
          setRoomList(roomList);
          setPatientDetails({ resCb });

          console.log("patient details data : ", patientdetails);
        }
      })
    );
  };

  function stripHtml(html) {
    if (!html) return "";
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  }

  const getDoctorList = () => {
    let data = {};
    let docList = [];
    dispatch(
      doctorActions.getDoctorList(data, (resCb) => {
        if (resCb) {
          console.log("doctorlist in packageservice", resCb);
          for (let doctorList of resCb) {
            if (
              doctorList &&
              doctorList.personId &&
              doctorList.type.toLowerCase() === "doctor"
            ) {
              docList.push(doctorList);
            }
          }
          setDoctorList([...docList]);
          console.log("doctorlist", docList);
          patientSummaryClick(docList, []); // Pass empty array for counselor list
        }
      })
    );
  };

  const getDoctorsList = (targetid, data) => {
    let gvdata;
    dispatch(
      doctorActions.getDoctorList(data, (resCb) => {
        if (resCb) {
          let list = [];
          console.log("rescb from getdoctorlist: ", resCb);
          for (let doc of resCb) {
            if (doc != null) {
              let opt = {};
              if (doc && !doc.first_name) {
                doc.first_name = "";
              }
              if (doc && !doc.last_name) {
                doc.last_name = "";
              }
              if (doc && doc.gvId) {
                opt["id"] = doc.personId;
                opt["gvid"] = doc.gvId;
              }
              const name = helperServices.getFullName(
                doc.first_name,
                null,
                doc.last_name
              );
              opt["role"] = doc.role;
              opt["type"] = doc.type;
              opt["value"] = doc.email;
              opt["department"] = doc.department;
              opt["firstName"] = doc.first_name;
              opt["lastName"] = doc.last_name;
              opt["departmentId"] = doc.departmentId;
              opt["label"] =
                doc.displaytitle +
                " " +
                name +
                ", " +
                "Dep of " +
                doc.department +
                " (" +
                doc.qualification +
                " )";
              list.push(opt);
              gvdata = targetid;
              console.log("gvdata and doc: ", gvdata, doc);
              if (gvdata && gvdata == doc.gvId) {
                setSelectedDoctor(doc.displaytitle + name);
              }
            }
          }
        }
      })
    );
  };

  const handleInputChange = (name, value) => {
    // Remove character limit validation entirely
    // Just update the summary state
    setSummary((prevSummary) => ({
      ...prevSummary,
      [name]: value,
    }));
  };

  // Autosave implementation:
  // - watches `summary` and `patientRevisitdetails`
  // - when mandatory fields are non-empty it triggers a debounced save
  // - avoids duplicate saves by comparing last saved snapshot
  const autosaveTimerRef = useRef(null);
  const lastSavedRef = useRef(null);
  const isAutosaveRunningRef = useRef(false);
  const mandatoryFilledTimeRef = useRef(null);
  const [autosaveStatus, setAutosaveStatus] = useState("idle"); // idle | saving | saved

  const getSummarySnapshot = () => {
    try {
      // Only store the relevant keys to avoid noise
      return JSON.stringify({
        summary,
        patientRevisitdetails,
        selectedItemsDoc,
      });
    } catch (e) {
      return null;
    }
  };

  const isMandatoryFilled = () => {
    // Mandatory fields: Final Diagnosis and Chief Complaints
    const finalDiag = stripHtml(summary["Final Diagnosis"] || "").trim();
    const chief = stripHtml(summary["Chief Complaints"] || "").trim();
    return finalDiag.length > 0 && chief.length > 0;
  };

  useEffect(() => {
    // Clean previous timer
    if (autosaveTimerRef.current) {
      clearTimeout(autosaveTimerRef.current);
      autosaveTimerRef.current = null;
    }

    // Check if mandatory fields are filled
    const mandatoryFilled = isMandatoryFilled();

    if (!mandatoryFilled) {
      // Reset the timer reference if mandatory fields become empty
      mandatoryFilledTimeRef.current = null;
      return;
    }

    // Record the time when mandatory fields were first filled
    if (!mandatoryFilledTimeRef.current) {
      mandatoryFilledTimeRef.current = Date.now();
    }

    const snapshot = getSummarySnapshot();
    if (!snapshot) return;

    // If nothing changed since last save, skip
    if (lastSavedRef.current && lastSavedRef.current === snapshot) {
      return;
    }

    // Wait 3 minutes (180000ms) after mandatory fields are filled before first autosave
    autosaveTimerRef.current = setTimeout(() => {
      // Prevent concurrent autosaves
      if (isAutosaveRunningRef.current) return;
      isAutosaveRunningRef.current = true;
      setAutosaveStatus("saving");

      // Validate mandatory fields locally before calling validateForm
      validateField("Final Diagnosis", summary["Final Diagnosis"]);
      validateField("Chief Complaints", summary["Chief Complaints"]);

      // A short delay to allow validation state to propagate (if needed)
      setTimeout(() => {
        // Call the existing validateForm which performs the save dispatches
        try {
          validateForm({});
        } catch (e) {
          console.error("Autosave validateForm error:", e);
        }

        // Mark saved locally. We cannot reliably know when server finishes here
        lastSavedRef.current = snapshot;
        setAutosaveStatus("saved");

        // reset status to idle after a short time
        setTimeout(() => setAutosaveStatus("idle"), 2000);
        isAutosaveRunningRef.current = false;
      }, 300);
    }, 180000); // 3 minutes = 180000ms

    return () => {
      if (autosaveTimerRef.current) {
        clearTimeout(autosaveTimerRef.current);
        autosaveTimerRef.current = null;
      }
    };
  }, [summary, patientRevisitdetails, selectedItemsDoc]);

  const handlePrint = (event, printType) => {
    console.log("In handlePrint change", summary);

    var summarydata = summary;

    // CRITICAL: Always rebuild the doctor list from current selectedItemsDoc state
    let nameList = [];

    // Use the current selectedItemsDoc state (which reflects removed doctors)
    if (selectedItemsDoc && selectedItemsDoc.length > 0) {
      console.log("Current selectedItemsDoc for print:", selectedItemsDoc);
      selectedItemsDoc.forEach((element) => {
        let name =
          element.displaytitle +
          element.first_name +
          " " +
          (element.last_name || "");
        console.log("Adding doctor to print list:", name);
        nameList.push(name);
      });
    }

    console.log("Final nameList for print:", nameList);

    // Update both doctors state and selectedDoctorNames to ensure consistency
    setDoctors(nameList);
    setSelectedDoctorNames(nameList);
    setSummary({ ...summarydata });
    setPrintPreviewType(printType);
    setdischargePrint(true);
  };

  const handleDischargePrint = () => {
    setdischargePrint(false);
  };

  // const validateField = (fieldName, htmlValue) => {
  //   let fieldValidationErrors = formErrors;
  //   const plainTextValue = stripHtml(htmlValue);

  //   switch (fieldName) {
  //     case "Final Diagnosis":
  //       fieldValidationErrors["Final Diagnosis"] =
  //         plainTextValue.length > 0 ? "" : "Please Enter Final Diagnosis";
  //       break;
  //     case "Chief Complaints":
  //       fieldValidationErrors["Chief Complaints"] =
  //         plainTextValue.length === 0
  //           ? "Please Enter Chief Complaints"
  //           : plainTextValue.length > 800
  //           ? "Chief Complaints exceed limit of 800 characters"
  //           : "";
  //       break;
  //     default:
  //       break;
  //   }
  //   setFormErrors(fieldValidationErrors);
  // };

  const validateField = (fieldName, htmlValue) => {
    let fieldValidationErrors = formErrors;
    const plainTextValue = stripHtml(htmlValue);

    switch (fieldName) {
      case "Final Diagnosis":
        fieldValidationErrors["Final Diagnosis"] =
          plainTextValue.length > 0 ? "" : "Please Enter Final Diagnosis";
        break;
      case "Chief Complaints":
        // Remove the character limit check
        fieldValidationErrors["Chief Complaints"] =
          plainTextValue.length === 0 ? "Please Enter Chief Complaints" : "";
        break;
      default:
        break;
    }
    setFormErrors(fieldValidationErrors);
  };

  const handleSubmit = (event, isupvote) => {
    let fieldValidationErrors = formErrors;
    let curDate = format(new Date(), "yyyy-MM-dd");
    console.log("date ::: ", patientRevisitdetails, curDate);
    fieldValidationErrors["Follow Up Date"] =
      patientRevisitdetails < curDate
        ? "Please Enter valid Follow up Date"
        : "";
    setFormErrors(fieldValidationErrors);
    Object.keys(summary).forEach((key) => {
      validateField(key, summary[key]);
      console.log("patientInfo:", event);
      console.log("summary[key]", summary[key], ":", key);
    });

    validateForm(event);

    setTimeout(() => {
      console.log("props:", props);
    }, 3000);
  };
  const setMessageStrip = (e) => {
    console.log("message obtained", e);
    var ServerResVal = ServerRes;
    if (e.success) {
      console.log("success message:", e.success);
      ServerResVal.success = e.success;
    } else {
      console.log("error message:", e.error);
      ServerResVal.error = e.error;
    }
    setServerRes({ ...ServerResVal });
    setTimeout(() => {
      closeAlert();
    }, 5000);
  };

  const validateForm = (event) => {
    console.log("formErrors : ", formErrors);
    let formValid =
      formErrors["Final Diagnosis"] === "" &&
      formErrors["Chief Complaints"] === "" &&
      formErrors["Follow Up Date"] === "";

    for (let key in formErrors) {
      if (formErrors[key] !== "") {
        setMessageStrip({
          error:
            "Please check there is a validation error in the discharge summary form",
        });
        return;
      }
    }

    if (formValid) {
      details.patientId = props.match.params.patientid;
      details.visitId = props.match.params.visitid;
      details.id = dischargeId;
      details.groupname = DISCHARGESUMMARY;
      console.log("In validateForm - summary state:", summary);

      var proList = [];
      var doctorlist = [];
      var dischargeddt = [];
      var ServerResVal = ServerRes;

      // Get all keys from the current summary state
      const keys = Object.keys(summary);
      console.log("All summary keys:", keys);

      for (let key of keys) {
        // Skip the dischargedt field as it's handled separately
        if (key === "dischargedt") {
          dischargeddt.push({
            id: props.match.params.visitid,
            patientId: props.match.params.patientid,
            dischargeDate: summary[key],
          });
          setDischrgeDetails(dischargeddt);
          continue;
        }

        const isCustomField = customFields.some((f) => f.key === key);
        if (isCustomField && isEmptyValue(summary[key])) {
          console.log(`Skipping empty custom field: ${key}`);
          continue;
        }

        // Find existing item to preserve its ID
        const existingItem = filterdProList
          ? filterdProList.find((item) => item.claSS === key)
          : null;

        proList.push({
          id: existingItem ? existingItem.id : null,
          claSS: key,
          notes: summary[key],
          patientId: props.match.params.patientid,
          visitId: props.match.params.visitid,
        });
        // console.log(`Prepared item for ${key}:`, itemToSave);
        console.log(`Content length for ${key}:`, summary[key]?.length || 0);
      }

      // Handle selected doctors during submit
      if (selectedItemsDoc && selectedItemsDoc.length > 0) {
        selectedItemsDoc.forEach((item) => {
          console.log("item : ", item);
          doctorlist.push({
            targetid: item.gvId,
            visitid: props.match.params.visitid,
            status: "open",
            type: "Doctor",
            groupname: item.groupname || "Treating_Doctor",
          });
          console.log("Insert Visit Assignment : ", doctorlist);
        });
      }

      let tempArray = {
        patientId: props.match.params.patientid,
        lastvisitId: props.match.params.visitid,
        scheduleddate: patientRevisitdetails,
      };

      console.log("Final proList to be saved:", proList);
      console.log("tempArray : ", tempArray, dischargeddt, dischrgeDetails);

      // Save data - all dispatch calls remain the same
      dispatch(
        patientActions.saveDischargeSummary(proList, (resCb) => {
          if (resCb) {
            if (resCb.successMessages) {
              ServerResVal.success = resCb.successMessages;
              setServerRes({ success: "Discharge summary added successfully" });
              saveDischargeSummaryinEhr();
            } else {
              ServerResVal.error = resCb.errorMessages;
              setServerRes({ error: "Failed to add Discharge summary" });
            }
            setTimeout(() => {
              setServerRes({ success: "", error: "" });
            }, 3000);
            setServerRes({ ...ServerResVal });
            console.log("resCb : ", resCb);
          }
        })
      );

      // Rest of the dispatch calls remain unchanged...
      dispatch(
        patientActions.followUpByDoctor(tempArray, (resCb) => {
          if (resCb) {
            if (resCb.successMessages) {
              ServerResVal.success = resCb.successMessages;
              setServerRes({ success: "Discharge summary added successfully" });
            } else {
              ServerResVal.error = resCb.errorMessages;
              setServerRes({ error: "Failed to add Discharge summary" });
            }
            setTimeout(() => {
              setServerRes({ success: "", error: "" });
            }, 3000);
            setServerRes({ ...ServerResVal });
            console.log("resCb : ", resCb);
          }
        })
      );

      dispatch(
        patientActions.saveVisitAssignment(doctorlist, (resCb) => {
          if (resCb) {
            if (resCb.successMessages) {
              ServerResVal.success = resCb.successMessages;
              setServerRes({
                success: "Discharge summary added successfully.",
              });
            } else {
              ServerResVal.error = resCb.errorMessages;
              setServerRes({ error: "Failed to add Discharge summary" });
            }
            setTimeout(() => {
              setServerRes({ success: "", error: "" });
            }, 3000);
            setServerRes({ ...ServerResVal });
            console.log("resCb : ", resCb);
          }
        })
      );

      dispatch(
        patientActions.saveDischargeDate(dischargeddt, (resCb) => {
          if (resCb) {
            if (resCb.successMessages) {
              ServerResVal.success = resCb.successMessages;
              setServerRes({
                success: "Discharge summary added successfully.",
              });
            } else {
              ServerResVal.error = resCb.errorMessages;
              setServerRes({ error: "Failed to add Discharge summary" });
            }
            setTimeout(() => {
              setServerRes({ success: "", error: "" });
            }, 3000);
            setServerRes({ ...ServerResVal });
            console.log("resCb : ", resCb);
          }
        })
      );

      setMessageStrip({ success: event.successMessages });
      setTimeout(() => {
        closeAlert();
      }, 3000);
    } else {
      setLoadSummary(!loadsummary);
      setMessageStrip({
        error:
          "Please check there is an validation error in the discharge summary form",
      });
    }
  };

  const isEmptyValue = (value) => {
    return stripHtml(value || "").trim() === "";
  };

  const printableCustomFields = customFields.filter(
    (field) => !isEmptyValue(summary[field.key])
  );


  const saveDischargeSummaryinEhr = () => {
    let templateId = "Discharge Summary";
    let patientId = props.match.params.patientid;
    let visitId = props.match.params.visitid;
    let template = {};
    console.log(
      "Doc in EHR",
      dischargeSummarytemplate.composer.name,
      selectedDoctor
    );
    // dischargeSummarytemplate.composer = dischargeSummarytemplate.composer || {};
    // dischargeSummarytemplate.composer.name=selectedDoctor;
    console.log(
      "dischargeSummarytemplate.content[0]",
      dischargeSummarytemplate.content[0]
    );
    dischargeSummarytemplate.content[0].items.map((item) => {
      let fieldname = item.name.value;
      let i = item?.data?.events?.[0]?.data?.items?.[0]?.value?.value;

      console.log("fieldname", fieldname, i);
      switch (fieldname) {
        case "Final Diagnosis":
          console.log("Final Diagnosis", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "Patient Status":
          console.log("Patient Status", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "Course in the hospital":
          console.log("Course in the hospital", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "Past History":
          console.log("Past History", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "Chief Complaints":
          console.log("Chief Complaints", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "Family History":
          console.log("Family History", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "Provisional Diagnosis":
          console.log("Provisional Diagnosis", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "Drug Allergy":
          console.log("Drug Allergy", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "History of presenting illness":
          console.log("History of presenting illness", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "History of present pregnancy":
          console.log("History of present pregnancy", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "Obstetric History":
          console.log("Obstetric History", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "Menstrual History":
          console.log("Menstrual History", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "General physical examination":
          console.log("General physical examination", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "Investigations":
          console.log("Investigations", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "Systemic Examination":
          console.log("Systemic Examination", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "Advice on discharge":
          console.log("Advice on discharge", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "Treatment given":
          console.log("Treatment given", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "Emergency Contact":
          console.log("Emergency Contact", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "Follow Up":
          console.log("Follow Up", summary[fieldname]);
          i = summary[fieldname] ? summary[fieldname] : i;
          break;
        case "FollowUp Date":
          console.log("FollowUp Date", patientRevisitdetails);
          i = patientRevisitdetails ? patientRevisitdetails : i;
          break;
        case "Discharge Date":
          console.log("Discharge Date", dischargedt);
          i = dischargedt ? dischargedt : i;
          break;
      }
      if (item?.data?.events?.[0]?.data?.items?.[0]?.value) {
        item.data.events[0].data.items[0].value.value = i;
        item.subject.name = selectedDoctor;
      }
    });

    console.log(
      "dischargeSummarytemplate.content[0]",
      dischargeSummarytemplate.content[0]
    );
    let notesDetails = "Discharge summary saved in ehr";
    let procedure = props.selectedProcedure ?? null;
    dispatch(
      ehrActions.saveComposition(
        dischargeSummarytemplate,
        patientId,
        visitId,
        templateId,
        patientEhrid,
        notesDetails,
        procedure,
        (resCb) => {
          if (resCb) {
            console.log("Diagnosis Master API Response:", resCb);
            console.log("Templateiddddd", templateId);
            // setSelectedPatientInfo(resCb)
            if (resCb.successMessages) {
            }
          }
        }
      )
    );
  };

  const closeAlert = () => {
    setServerRes({ ..."" });
  };

  const handleOptionSelect = (selectedDoctorId, type) => {
    doctorList.forEach((doc) => {
      if (doc.gvId == selectedDoctorId) {
        // Create a copy of the doctor object with groupname
        const doctorWithGroupname = { ...doc, groupname: type };

        const fullName = `${doc.displaytitle} ${doc.first_name} ${doc.last_name || ""
          }`;

        // Add to selected doctor names if not already included
        setSelectedDoctorNames((prev) => {
          if (!prev.includes(fullName)) {
            return [...prev, fullName];
          }
          return prev;
        });

        // Add to selected items if not already present
        if (!selectedItemsDoc.some((item) => item.gvId === doc.gvId)) {
          setSelectedItemsDoc((prevItems) => [
            ...prevItems,
            doctorWithGroupname,
          ]);
        } else {
          // Update existing doctor with new groupname
          setSelectedItemsDoc((prevItems) =>
            prevItems.map((item) =>
              item.gvId === doc.gvId ? { ...item, groupname: type } : item
            )
          );
        }
      }
    });
  };

  // const handleRemoveItem = (item) => {
  //   const updatedItems = selectedItemsDoc.filter(
  //     (selectedItem) => selectedItem !== item
  //   );
  //   setSelectedItemsDoc(updatedItems);
  // };

  const handleRemoveItem = (item) => {
    console.log("Removing doctor:", item);

    // Remove from selectedItemsDoc
    const updatedItems = selectedItemsDoc.filter(
      (selectedItem) => selectedItem.gvId !== item.gvId
    );
    setSelectedItemsDoc(updatedItems);

    // Also remove from selectedDoctorNames
    const fullName = `${item.displaytitle} ${item.first_name} ${item.last_name || ""
      }`;
    setSelectedDoctorNames((prev) => prev.filter((name) => name !== fullName));

    // Update doctors list for print
    const updatedDoctorNames = updatedItems.map(
      (doc) => `${doc.displaytitle} ${doc.first_name} ${doc.last_name || ""}`
    );
    setDoctors(updatedDoctorNames);

    console.log("Updated selectedItemsDoc:", updatedItems);
    console.log("Updated doctor names:", updatedDoctorNames);
  };

  const ChangeRevisitDate = (event) => {
    var val = event.target.value;
    let fieldValidationErrors = formErrors;
    setPatientRevisitdetails(val);
    console.log("revisit date : ", patientRevisitdetails, val);
    let curDate = format(new Date(), "yyyy-MM-dd");
    console.log("date ::: ", patientRevisitdetails, curDate);
    fieldValidationErrors["Follow Up Date"] =
      val < curDate ? "Please Enter valid Follow up Date" : "";
    setFormErrors(fieldValidationErrors);
  };

  return (
    <>
      <style>{styles}</style>

      {showAddFieldModal && (
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New Field</h5>
                <Button
                  variant="text"
                  onClick={() => {
                    setShowAddFieldModal(false);
                    setNewFieldName("");
                    setNewFieldValue("");
                  }}
                  style={{ minWidth: "auto", padding: 0 }}
                >
                  <CloseIcon />
                </Button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <TextField
                    fullWidth
                    label="Field Name"
                    value={newFieldName}
                    onChange={(e) => setNewFieldName(e.target.value)}
                    placeholder="Leave blank for 'Additional Comment'"
                    autoFocus // ✅ Auto-focus this field on open
                  />
                </div>
                <div className="mb-3">
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Field Value"
                    value={newFieldValue}
                    onChange={(e) => setNewFieldValue(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer">
                {/* Cancel Button - Styled like your other action buttons */}
                <Button
                  variant="contained"
                  color="primary"
                  className="buttOnMui"
                  onClick={() => {
                    setShowAddFieldModal(false);
                    setNewFieldName("");
                    setNewFieldValue("");
                  }}
                  style={{ textTransform: "none", marginRight: "20px" }}
                >
                  Cancel
                </Button>

                {/* Add Field Button - Styled like your other action buttons */}
                <Button
                  variant="contained"
                  color="primary"
                  className="buttOnMui"
                  onClick={() => {
                    if (newFieldValue.trim()) {
                      const fieldName =
                        newFieldName.trim() || "Additional Comment";
                      const fieldKey = fieldName.replace(/\s+/g, "_");
                      setCustomFields([
                        ...customFields,
                        { name: fieldName, key: fieldKey },
                      ]);
                      setSummary((prev) => ({
                        ...prev,
                        [fieldKey]: newFieldValue,
                      }));
                      setFormErrors((prev) => ({
                        ...prev,
                        [fieldKey]: "",
                      }));
                      setNewFieldName("");
                      setNewFieldValue("");
                      setShowAddFieldModal(false);
                    }
                  }}
                  style={{ textTransform: "none" }}
                >
                  Add Field
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {ServerRes.success && (
        <Alert severity="success" className="alert-div">
          {ServerRes.success}{" "}
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={(event) => closeAlert(event)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Alert>
      )}
      {ServerRes.error && (
        <Alert severity="error" className="alert-div">
          {ServerRes.error}{" "}
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={(event) => closeAlert(event)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Alert>
      )}
      <div
        className="bg-none nav-wrapper h-100 d-flex flex-column summary-view"
        key={loadsummary}
      >
        <div className="pres-header">
          {/* Autosave status indicator */}
          <div style={{ position: "absolute", right: 16, top: 12, zIndex: 10 }}>
            {autosaveStatus === "saving" && (
              <small style={{ color: "#1976d2" }}>Autosaving...</small>
            )}
            {autosaveStatus === "saved" && (
              <small style={{ color: "#2e7d32" }}>Autosaved</small>
            )}
          </div>
          <div className="pres-layout-basic-info">
            <div className="main-content-container container-fluid p-0">
              <div className="mb-12 col-md-12 hpcol bg menu-head">
                <div className="blog-comments__item d-flex cpointer  p-2 menu-content">
                  <div className="">
                    <div className="blog-comments__content layout-head-content">
                      <div className="blog-comments__meta text-mutes d-flex img-name justify-content-between">
                        <div className="d-flex align-items-center">
                          <div
                            className="text-secondary pname px-2"
                            style={{
                              textTransform: "capitalize",
                              margin: "right",
                            }}
                          >
                            {fullName}({props.match.params.patientid},
                            {props.match.params.visitid})
                          </div>
                        </div>
                        <div className="d-flex flex-column">
                          {/* {roomName && (
                            <small
                              className="text-muted"
                              style={{ fontWeight: "500" }}
                            >
                              <span>Room Name: {roomName}</span>
                            </small>
                          )} */}
                          {Array.isArray(roomList) && roomList.length > 0 && (
                            <small
                              className="text-muted"
                              style={{
                                fontWeight: 300,
                                display: "flex",
                                gap: "8px",
                                flexWrap: "wrap",
                                alignItems: "center",
                              }}
                            >
                              <i className="material-icons p-icon">bed</i>
                              {roomList.map((room) => room.roomName).join(", ")}
                            </small>
                          )}

                          {phoneNum && (
                            <small
                              className="text-muted"
                              style={{
                                fontWeight: 300,
                                display: "flex",
                                gap: "8px",
                                flexWrap: "wrap",
                                alignItems: "center",
                              }}
                            >
                              <i className="material-icons p-icon">phone</i>
                              <span>{phoneNum}</span>
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex h-100  px-3" id="discharge">
          <div className="px-2 w-100">
            <div
              className="w-100 service-container"
              style={{ overflowY: "auto" }}
            >
              <div className="w-100 flex-wrap flex-column px-3">
                <span>
                  <Box className="row service-form">
                    <div
                      className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Course in the hospital"
                        ? "focused-editor"
                        : ""
                        }`}
                      id="bgclr"
                      data-field="Course in the hospital"
                      //onKeyDown={(e) => handleTabNavigation(e, "Course in the hospital")}
                      onKeyDownCapture={(e) =>
                        handleTabNavigation(e, "Course in the hospital")
                      }
                    >
                      <label className="summary-label">
                        Course in the hospital
                      </label>
                      <SunEditor
                        key={`course-hospital-${summary["Course in the hospital"]?.length || 0
                          }-${loadsummary}`}
                        setOptions={options}
                        setContents={summary["Course in the hospital"] || ""}
                        onChange={(value) =>
                          handleInputChange("Course in the hospital", value)
                        }
                        onFocus={() =>
                          setFocusedField("Course in the hospital")
                        }
                        onBlur={() => setFocusedField(null)}
                        placeholder="Course in the hospital"
                        hideToolbar={focusedField !== "Course in the hospital"}
                      />
                    </div>

                    <div
                      className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Emergency Contact"
                        ? "focused-editor"
                        : ""
                        }`}
                      id="bgclr"
                      data-field="Emergency Contact"
                      onKeyDownCapture={(e) =>
                        handleTabNavigation(e, "Emergency Contact")
                      }
                    >
                      <label className="summary-label">Emergency Contact</label>
                      <SunEditor
                        setOptions={options} // you already defined options above
                        //                     setOptions={{
                        //   ...options,
                        //   // Add this to handle keydown events
                        //   callBackSave: function(contents, isChanged) {
                        //     handleInputChange("Emergency Contact", contents);
                        //   }
                        // }}

                        setContents={summary["Emergency Contact"] || ""}
                        onChange={(value) =>
                          handleInputChange("Emergency Contact", value)
                        }
                        onFocus={() => setFocusedField("Emergency Contact")}
                        onBlur={() => setFocusedField(null)}
                        placeholder="Emergency Contact"
                        hideToolbar={focusedField !== "Emergency Contact"}
                      />
                    </div>

                    <div
                      className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Referred By" ? "focused-editor" : ""
                        }`}
                      id="bgclr"
                      data-field="Referred By"
                      onKeyDown={(e) => handleTabNavigation(e, "Referred By")}
                    >
                      <label className="summary-label">Referred By</label>
                      <SunEditor
                        setOptions={options} // you already defined options above
                        //                     setOptions={{
                        //   ...options,
                        //   // Add this to handle keydown events
                        //   callBackSave: function(contents, isChanged) {
                        //     handleInputChange("Referred By", contents);
                        //   }
                        // }}
                        setContents={summary["Referred By"] || ""}
                        onChange={(value) =>
                          handleInputChange("Referred By", value)
                        }
                        onFocus={() => setFocusedField("Referred By")}
                        onBlur={() => setFocusedField(null)}
                        placeholder="Referred By"
                        hideToolbar={focusedField !== "Referred By"}
                      />
                    </div>

                    <div className="py-3 pl-0  col-lg-3" id="bgclr">
                      <FormControlLabel
                        control={
                          <Switch
                            checked={isOn}
                            onChange={toggleSwitch}
                            color="primary"
                          />
                        }
                        label={isOn ? "Gynae" : "Normal"}
                      />
                    </div>

                    <div
                      className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Referred To" ? "focused-editor" : ""
                        }`}
                      id="bgclr"
                      data-field="Referred To"
                      onKeyDown={(e) => handleTabNavigation(e, "Referred To")}
                    >
                      <label className="summary-label">Referred To</label>
                      <SunEditor
                        setOptions={options} // you already defined options above
                        //                     setOptions={{
                        //   ...options,
                        //   // Add this to handle keydown events
                        //   callBackSave: function(contents, isChanged) {
                        //     handleInputChange("Referred To", contents);
                        //   }
                        // }}
                        setContents={summary["Referred To"] || ""}
                        onChange={(value) =>
                          handleInputChange("Referred To", value)
                        }
                        onFocus={() => setFocusedField("Referred To")}
                        onBlur={() => setFocusedField(null)}
                        placeholder="Referred To"
                        hideToolbar={focusedField !== "Referred To"}
                      />
                    </div>

                    <div
                      className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Final Diagnosis"
                        ? "focused-editor"
                        : ""
                        }`}
                      id="bgclr"
                      data-field="Final Diagnosis"
                      onKeyDown={(e) =>
                        handleTabNavigation(e, "Final Diagnosis")
                      }
                    >
                      <label className="summary-label">
                        Final Diagnosis{" "}
                        <span
                          className={`${classes.redAsterisk} MuiInputLabel-asterisk`}
                        >
                          *
                        </span>
                      </label>
                      <SunEditor
                        setOptions={options} // keep toolbar options same always
                        //                     setOptions={{
                        //   ...options,
                        //   // Add this to handle keydown events
                        //     callBackSave: function(contents, isChanged) {
                        //     handleInputChange("Final Diagnosis", contents);
                        //   }
                        // }}

                        setContents={summary["Final Diagnosis"] || ""}
                        onChange={(value) => {
                          handleInputChange("Final Diagnosis", value); // save only plain text
                        }}
                        onFocus={() => setFocusedField("Final Diagnosis")}
                        onBlur={() => setFocusedField(null)}
                        placeholder="Final Diagnosis"
                        hideToolbar={focusedField !== "Final Diagnosis"}
                      />

                      <div style={{ color: "#EC4147" }}>
                        <span className="summary-label">
                          {formErrors["Final Diagnosis"]}
                        </span>
                      </div>
                    </div>

                    <div
                      className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Chief Complaints"
                        ? "focused-editor"
                        : ""
                        }`}
                      id="bgclr"
                      data-field="Chief Complaints"
                      onKeyDown={(e) =>
                        handleTabNavigation(e, "Chief Complaints")
                      }
                    >
                      <label className="summary-label">
                        Chief Complaints{" "}
                        <span
                          className={`${classes.redAsterisk} MuiInputLabel-asterisk`}
                        >
                          *
                        </span>
                      </label>
                      <SunEditor
                        setOptions={options} // toolbar config
                        //                     setOptions={{
                        //   ...options,
                        //   // Add this to handle keydown events
                        //   callBackSave: function(contents, isChanged) {
                        //     handleInputChange("Chief Complaints", contents);
                        //   }
                        // }}
                        setContents={summary["Chief Complaints"] || ""}
                        onChange={(value) =>
                          handleInputChange("Chief Complaints", value)
                        }
                        onFocus={() => setFocusedField("Chief Complaints")}
                        onBlur={() => setFocusedField(null)}
                        placeholder="Chief Complaints"
                        hideToolbar={focusedField !== "Chief Complaints"}
                      />
                      <div style={{ color: "#EC4147" }}>
                        <span className="summary-label">
                          {formErrors["Chief Complaints"]}
                        </span>
                      </div>
                    </div>

                    <div
                      className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Patient Status"
                        ? "focused-editor"
                        : ""
                        }`}
                      id="bgclr"
                      data-field="Patient Status"
                      onKeyDown={(e) =>
                        handleTabNavigation(e, "Patient Status")
                      }
                    >
                      <label className="summary-label">Patient Status</label>
                      <SunEditor
                        setOptions={options}
                        setContents={summary["Patient Status"] || ""}
                        onChange={(value) =>
                          handleInputChange("Patient Status", value)
                        }
                        onFocus={() => setFocusedField("Patient Status")}
                        onBlur={() => setFocusedField(null)}
                        placeholder="Patient Status"
                        hideToolbar={focusedField !== "Patient Status"}
                      />
                    </div>

                    {isOn && (
                      <div
                        className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "History of present pregnancy"
                          ? "focused-editor"
                          : ""
                          }`}
                        id="bgclr"
                        data-field="History of present pregnancy"
                        onKeyDown={(e) =>
                          handleTabNavigation(e, "History of present pregnancy")
                        }
                      >
                        <label className="summary-label">
                          History of present pregnancy
                        </label>
                        <SunEditor
                          setOptions={options} // you already defined options above
                          setContents={
                            summary["History of present pregnancy"] || ""
                          }
                          onChange={(value) =>
                            handleInputChange(
                              "History of present pregnancy",
                              value
                            )
                          }
                          onFocus={() =>
                            setFocusedField("History of present pregnancy")
                          }
                          onBlur={() => setFocusedField(null)}
                          placeholder="History of present pregnancy"
                          hideToolbar={
                            focusedField !== "History of present pregnancy"
                          }
                        />
                      </div>
                    )}

                    <div
                      className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Past History" ? "focused-editor" : ""
                        }`}
                      id="bgclr"
                      data-field="Past History"
                      onKeyDown={(e) => handleTabNavigation(e, "Past History")}
                    >
                      <label className="summary-label">Past History</label>
                      <SunEditor
                        setOptions={options} // you already defined options above
                        setContents={summary["Past History"] || ""}
                        onChange={(value) =>
                          handleInputChange("Past History", value)
                        }
                        onFocus={() => setFocusedField("Past History")}
                        onBlur={() => setFocusedField(null)}
                        placeholder="Past History"
                        hideToolbar={focusedField !== "Past History"}
                      />
                    </div>

                    <div
                      className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Family History"
                        ? "focused-editor"
                        : ""
                        }`}
                      //id="bgclr"
                      data-field="Family History"
                      onKeyDown={(e) =>
                        handleTabNavigation(e, "Family History")
                      }
                    >
                      <label className="summary-label">Family History</label>
                      <SunEditor
                        setOptions={options} // you already defined options above
                        setContents={summary["Family History"] || ""}
                        onChange={(value) =>
                          handleInputChange("Family History", value)
                        }
                        onFocus={() => setFocusedField("Family History")}
                        onBlur={() => setFocusedField(null)}
                        placeholder="Family History"
                        hideToolbar={focusedField !== "Family History"}
                      />
                    </div>

                    {!isOn && (
                      <div
                        className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "History of presenting illness"
                          ? "focused-editor"
                          : ""
                          }`}
                        id="bgclr"
                        data-field="History of presenting illness"
                        onKeyDown={(e) =>
                          handleTabNavigation(
                            e,
                            "History of presenting illness"
                          )
                        }
                      >
                        <label className="summary-label">
                          History of presenting illness
                        </label>
                        <SunEditor
                          setOptions={options} // you already defined options above
                          setContents={
                            summary["History of presenting illness"] || ""
                          }
                          onChange={(value) =>
                            handleInputChange(
                              "History of presenting illness",
                              value
                            )
                          }
                          onFocus={() =>
                            setFocusedField("History of presenting illness")
                          }
                          onBlur={() => setFocusedField(null)}
                          placeholder="History of presenting illness"
                          hideToolbar={
                            focusedField !== "History of presenting illness"
                          }
                        />
                      </div>
                    )}
                    {isOn && (
                      <div
                        className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Obstetric history"
                          ? "focused-editor"
                          : ""
                          }`}
                        id="bgclr"
                        data-field="Obstetric history"
                        onKeyDown={(e) =>
                          handleTabNavigation(e, "Obstetric history")
                        }
                      >
                        <label className="summary-label">
                          Obstetric history
                        </label>
                        <SunEditor
                          setOptions={options} // you already defined options above
                          setContents={summary["Obstetric history"] || ""}
                          onChange={(value) =>
                            handleInputChange("Obstetric history", value)
                          }
                          onFocus={() => setFocusedField("Obstetric history")}
                          onBlur={() => setFocusedField(null)}
                          placeholder="Obstetric history"
                          hideToolbar={focusedField !== "Obstetric history"}
                        />
                      </div>
                    )}
                    {isOn && (
                      <div
                        className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Menstrual history"
                          ? "focused-editor"
                          : ""
                          }`}
                        id="bgclr"
                        data-field="Menstrual history"
                        onKeyDown={(e) =>
                          handleTabNavigation(e, "Menstrual history")
                        }
                      >
                        <label className="summary-label">
                          Menstrual history
                        </label>
                        <SunEditor
                          setOptions={options} // you already defined options above
                          setContents={summary["Menstrual history"] || ""}
                          onChange={(value) =>
                            handleInputChange("Menstrual history", value)
                          }
                          onFocus={() => setFocusedField("Menstrual history")}
                          onBlur={() => setFocusedField(null)}
                          placeholder="Menstrual history"
                          hideToolbar={focusedField !== "Menstrual history"}
                        />
                      </div>
                    )}

                    <div
                      className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Systemic Examination"
                        ? "focused-editor"
                        : ""
                        }`}
                      id="bgclr"
                      data-field="Systemic Examination"
                      onKeyDown={(e) =>
                        handleTabNavigation(e, "Systemic Examination")
                      }
                    >
                      <label className="summary-label">
                        Systemic Examination
                      </label>
                      <SunEditor
                        setOptions={options} // you already defined options above
                        setContents={summary["Systemic Examination"] || ""}
                        onChange={(value) =>
                          handleInputChange("Systemic Examination", value)
                        }
                        onFocus={() => setFocusedField("Systemic Examination")}
                        onBlur={() => setFocusedField(null)}
                        placeholder="Systemic Examination"
                        hideToolbar={focusedField !== "Systemic Examination"}
                      />
                    </div>

                    <div
                      className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "General physical examination"
                        ? "focused-editor"
                        : ""
                        }`}
                      id="bgclr"
                      data-field="General physical examination"
                      onKeyDown={(e) =>
                        handleTabNavigation(e, "General physical examination")
                      }
                    >
                      <label className="summary-label">
                        General physical examination
                      </label>
                      <SunEditor
                        setOptions={options} // you already defined options above
                        setContents={
                          summary["General physical examination"] || ""
                        }
                        onChange={(value) =>
                          handleInputChange(
                            "General physical examination",
                            value
                          )
                        }
                        onFocus={() =>
                          setFocusedField("General physical examination")
                        }
                        onBlur={() => setFocusedField(null)}
                        placeholder="General physical examination"
                        hideToolbar={
                          focusedField !== "General physical examination"
                        }
                      />
                    </div>

                    <div
                      className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Treatment given"
                        ? "focused-editor"
                        : ""
                        }`}
                      id="bgclr"
                      data-field="Treatment given"
                      onKeyDown={(e) =>
                        handleTabNavigation(e, "Treatment given")
                      }
                    >
                      <label className="summary-label">Treatment given</label>
                      <SunEditor
                        setOptions={options} // you already defined options above
                        setContents={summary["Treatment given"] || ""}
                        onChange={(value) =>
                          handleInputChange("Treatment given", value)
                        }
                        onFocus={() => setFocusedField("Treatment given")}
                        onBlur={() => setFocusedField(null)}
                        placeholder="Treatment given"
                        hideToolbar={focusedField !== "Treatment given"}
                      />
                    </div>

                    <div
                      className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Investigations"
                        ? "focused-editor"
                        : ""
                        }`}
                      id="bgclr"
                      data-field="Investigations"
                      onKeyDown={(e) =>
                        handleTabNavigation(e, "Investigations")
                      }
                    >
                      <label className="summary-label">Investigations</label>
                      <SunEditor
                        setOptions={options} // you already defined options above
                        setContents={summary["Investigations"] || ""}
                        onChange={(value) =>
                          handleInputChange("Investigations", value)
                        }
                        onFocus={() => setFocusedField("Investigations")}
                        onBlur={() => setFocusedField(null)}
                        placeholder="Investigations"
                        hideToolbar={focusedField !== "Investigations"}
                      />
                    </div>

                    <div
                      className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Provisional Diagnosis"
                        ? "focused-editor"
                        : ""
                        }`}
                      id="bgclr"
                      data-field="Provisional Diagnosis"
                      onKeyDown={(e) =>
                        handleTabNavigation(e, "Provisional Diagnosis")
                      }
                    >
                      <label className="summary-label">
                        Provisional Diagnosis
                      </label>
                      <SunEditor
                        setOptions={options} // you already defined options above
                        setContents={summary["Provisional Diagnosis"] || ""}
                        onChange={(value) =>
                          handleInputChange("Provisional Diagnosis", value)
                        }
                        onFocus={() => setFocusedField("Provisional Diagnosis")}
                        onBlur={() => setFocusedField(null)}
                        placeholder="Provisional Diagnosis"
                        hideToolbar={focusedField !== "Provisional Diagnosis"}
                      />
                    </div>

                    <div
                      className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Advice on discharge"
                        ? "focused-editor"
                        : ""
                        }`}
                      id="bgclr"
                      data-field="Advice on discharge"
                      onKeyDown={(e) =>
                        handleTabNavigation(e, "Advice on discharge")
                      }
                    >
                      <label className="summary-label">
                        Advice on discharge
                      </label>
                      <SunEditor
                        setOptions={options} // you already defined options above
                        setContents={summary["Advice on discharge"] || ""}
                        onChange={(value) =>
                          handleInputChange("Advice on discharge", value)
                        }
                        onFocus={() => setFocusedField("Advice on discharge")}
                        onBlur={() => setFocusedField(null)}
                        placeholder="Advice on discharge"
                        hideToolbar={focusedField !== "Advice on discharge"}
                      />
                    </div>

                    <div
                      className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Drug Allergy" ? "focused-editor" : ""
                        }`}
                      id="bgclr"
                      data-field="Drug Allergy"
                      onKeyDown={(e) => handleTabNavigation(e, "Drug Allergy")}
                    >
                      <label className="summary-label">Drug Allergy</label>
                      <SunEditor
                        setOptions={options} // you already defined options above
                        setContents={summary["Drug Allergy"] || ""}
                        onChange={(value) =>
                          handleInputChange("Drug Allergy", value)
                        }
                        onFocus={() => setFocusedField("Drug Allergy")}
                        onBlur={() => setFocusedField(null)}
                        placeholder="Drug Allergy"
                        hideToolbar={focusedField !== "Drug Allergy"}
                      />
                    </div>

                    <div
                      className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === "Follow Up" ? "focused-editor" : ""
                        }`}
                      id="bgclr"
                      data-field="Follow Up"
                      onKeyDown={(e) => handleTabNavigation(e, "Follow Up")}
                    >
                      <label className="summary-label">Follow Up</label>
                      <SunEditor
                        setOptions={options} // you already defined options above
                        setContents={summary["Follow Up"] || ""}
                        onChange={(value) =>
                          handleInputChange("Follow Up", value)
                        }
                        onFocus={() => setFocusedField("Follow Up")}
                        onBlur={() => setFocusedField(null)}
                        placeholder="Follow Up"
                        hideToolbar={focusedField !== "Follow Up"}
                      />
                    </div>

                    {customFields.map((field) => (
                      <div
                        key={field.key}
                        className={`py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12 ${focusedField === field.key ? "focused-editor" : ""
                          }`}
                        id="bgclr"
                        data-field={field.key}
                        onKeyDown={(e) => handleTabNavigation(e, field.key)}
                      >
                        <label className="summary-label">{field.name}</label>
                        <SunEditor
                          setOptions={options} // use the same toolbar options
                          setContents={summary[field.key] || ""}
                          onChange={(value) =>
                            handleInputChange(field.key, value)
                          }
                          onFocus={() => setFocusedField(field.key)}
                          onBlur={() => setFocusedField(null)}
                          placeholder={field.name}
                          hideToolbar={focusedField !== field.key}
                        />
                      </div>
                    ))}

                    {/*  */}
                    <div className="py-3 pl-0 col-lg-3 col-xl-3 col-md-3 col-12">
                      <label className="summary-label">Treating Doctor</label>

                      <select
                        name="category"
                        className="form-control filterin Quantity"
                        value={selectedOptionDoc}
                        onChange={(e) => {
                          // Prevent automatic selection on change
                          e.preventDefault();
                        }}
                        onKeyDown={handleDoctorSelectKeyDown}
                        onFocus={(e) => {
                          setFocusedField("treating-doctor");
                          setHighlightedDoctorIndex(-1); // Reset highlight index
                          // Open dropdown when focused via Tab
                          e.target.size = Math.min(doctorList.length + 1, 10);
                        }}
                        onBlur={(e) => {
                          // Close dropdown when focus is lost
                          e.target.size = 0;
                          setHighlightedDoctorIndex(-1);
                        }}
                        data-tab-field="treating-doctor"
                      >
                        <option disabled value="">
                          ---Select doctor---
                        </option>
                        {doctorList.map((doctor, index) => (
                          <option
                            key={doctor.gvId}
                            value={doctor.gvId}
                            style={{
                              backgroundColor:
                                highlightedDoctorIndex === index
                                  ? "#1976d2"
                                  : "white",
                              color:
                                highlightedDoctorIndex === index
                                  ? "white"
                                  : "black",
                            }}
                          >
                            {doctor.displaytitle} {doctor.first_name}
                          </option>
                        ))}
                      </select>

                      <br />
                    </div>

                    <div className="py-3 pl-0 col-lg-3 col-xl-3 col-md-3 col-12">
                      <label className="summary-label">Selected Doctors</label>
                      {selectedItemsDoc.length > 0 && (
                        <div
                          className="border"
                          style={{
                            maxHeight: "140px",
                            overflowY: "auto",
                            borderRadius: "5px",
                            background: "white",
                          }}
                        >
                          {selectedItemsDoc.map((item) => (
                            <div
                              key={item.gvId}
                              className="d-flex p-1"
                              style={{
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <label>
                                {item.displaytitle} {item.first_name}
                              </label>
                              <button
                                type="button"
                                id="we"
                                className="btn btn-primary"
                                onClick={() => handleRemoveItem(item)}
                              >
                                Cancel
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* --- */}
                    <div className="py-3 pl-0 col-lg-12">
                      <div className="row">
                        <div
                          className="col-lg-6"
                          style={{ width: "fit-Content" }}
                        >
                          <label className="service-lable">
                            Follow Up Date
                          </label>
                          <input
                            name="scheduleddate"
                            id="scheduleddate"
                            className="form-control filterin Quantity"
                            required
                            type="date"
                            readOnly={followUpDateFlag}
                            min={todayDate}
                            defaultValue={patientRevisitdetails}
                            onChange={ChangeRevisitDate}
                            onKeyDown={(e) =>
                              handleTabNavigation(e, "follow-up-date")
                            }
                            onFocus={() => setFocusedField("follow-up-date")}
                            data-tab-field="follow-up-date"
                          />
                          <div style={{ color: "#EC4147" }}>
                            <span className="summary-label">
                              {formErrors["Follow Up Date"]}
                            </span>
                          </div>
                        </div>
                        <div
                          className="col-lg-6"
                          style={{ width: "fit-Content" }}
                        >
                          <label className="service-lable">
                            Discharge Date
                          </label>
                          <input
                            name="dischargedate"
                            id="dischargedate"
                            className="form-control filterin Quantity"
                            required
                            type="datetime-local"
                            readOnly={dischargeDateFlag}
                            min={todayDate}
                            value={summary.dischargedt}
                            onChange={(e) =>
                              handleInputChange("dischargedt", e.target.value)
                            }
                            onKeyDown={(e) =>
                              handleTabNavigation(e, "discharge-date")
                            }
                            onFocus={() => setFocusedField("discharge-date")}
                            data-tab-field="discharge-date"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="d-flex mx-1">
                      <Button
                        variant="contained"
                        color="primary"
                        className={`buttOnMui ${focusedField === "save-button" ? "focused-btn" : ""
                          }`}
                        onClick={(event) => handleSubmit(event)}
                        onFocus={() => setFocusedField("save-button")}
                        onBlur={() => setFocusedField(null)}
                        onKeyDown={(e) => handleTabNavigation(e, "save-button")}
                        data-tab-field="save-button"
                        style={{
                          textTransform: "none",
                          marginRight: "20px",
                          boxShadow:
                            focusedField === "save-button"
                              ? "0 4px 12px rgba(25, 118, 210, 0.4)"
                              : "none",
                        }}
                      >
                        Save
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        className={`buttOnMui ${focusedField === "print-button" ? "focused-btn" : ""
                          }`}
                        onClick={(event) => handlePrint(event, PRINT_FILE)}
                        onFocus={() => setFocusedField("print-button")}
                        onBlur={() => setFocusedField(null)}
                        onKeyDown={(e) =>
                          handleTabNavigation(e, "print-button")
                        }
                        data-tab-field="print-button"
                        style={{
                          textTransform: "none",
                          marginRight: "20px",
                          boxShadow:
                            focusedField === "print-button"
                              ? "0 4px 12px rgba(25, 118, 210, 0.4)"
                              : "none",
                        }}
                      >
                        Print
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        className={`buttOnMui ${focusedField === "preview-button" ? "focused-btn" : ""
                          }`}
                        onClick={(event) => handlePrint(event, PRINT_PREVIEW)}
                        onFocus={() => setFocusedField("preview-button")}
                        onBlur={() => setFocusedField(null)}
                        onKeyDown={(e) =>
                          handleTabNavigation(e, "preview-button")
                        }
                        data-tab-field="preview-button"
                        style={{
                          textTransform: "none",
                          marginRight: "20px",
                          boxShadow:
                            focusedField === "preview-button"
                              ? "0 4px 12px rgba(25, 118, 210, 0.4)"
                              : "none",
                        }}
                      >
                        Preview
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        className={`buttOnMui ${focusedField === "add-field-button"
                          ? "focused-btn"
                          : ""
                          }`}
                        onClick={() => setShowAddFieldModal(true)}
                        onFocus={() => setFocusedField("add-field-button")}
                        onBlur={() => setFocusedField(null)}
                        onKeyDown={(e) =>
                          handleTabNavigation(e, "add-field-button")
                        }
                        data-tab-field="add-field-button"
                        style={{
                          textTransform: "none",
                          marginRight: "20px",
                          boxShadow:
                            focusedField === "add-field-button"
                              ? "0 4px 12px rgba(25, 118, 210, 0.4)"
                              : "none",
                        }}
                      >
                        Add Field
                      </Button>
                    </div>

                    {dischargePrint && dischargePrint === true ? (
                      <div className="">
                        <Components.PrintMnhDischargeSummary
                          parentCallBack={handleDischargePrint}
                          patientdetails={patientdetails}
                          //treatingDoctor={selectedOptionDoc}
                          treatingDoctor={selectedDoctorNames}
                          revisitDetails={patientRevisitdetails}
                          doctorList={doctors}
                          isOn={isOn}
                          summary={summary}
                          customFields={printableCustomFields}
                          printPreviewType={printPreviewType}
                          enteredBy={enteredBy}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </Box>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default MnhDischargeSummary;
